/**
 * SMS Followup Filters API wrapper
 *
 * GET /api/v1/followup-filters - List all filters across all brands
 * GET /api/v1/followup-filters?brand_id=123 - List filters for a specific brand
 * GET /api/v1/followup-filters?brand_id=123&filter_type=subscription.created - Get a specific filter
 * POST /api/v1/followup-filters - Create/update filters
 * DELETE /api/v1/followup-filters?brand_id=123&filter_type=subscription.created - Delete a filter
 */

import { api } from "../common/utils"
import { FOLLOWUP_FILTERS_ENDPOINT } from "../common/constants"
import {
  FollowupFiltersResponse,
  FollowupFiltersAllResponse,
  FollowupFiltersPayload,
  FollowupFilterType
} from "../types"

const followupFiltersApi = {
  getByBrand: async (brandId: string): Promise<FollowupFiltersResponse> => {
    const { data } = await api.get(FOLLOWUP_FILTERS_ENDPOINT, {
      params: { brand_id: brandId }
    })
    return data
  },

  upsert: async (payload: FollowupFiltersPayload): Promise<void> => {
    await api.post(FOLLOWUP_FILTERS_ENDPOINT, payload)
  },

  delete: async (
    brandId: string,
    filterType: FollowupFilterType
  ): Promise<void> => {
    await api.delete(FOLLOWUP_FILTERS_ENDPOINT, {
      params: { brand_id: brandId, filter_type: filterType }
    })
  },

  getAll: async (): Promise<FollowupFiltersAllResponse> => {
    const { data } = await api.get(FOLLOWUP_FILTERS_ENDPOINT)
    return data
  }
}

export default followupFiltersApi
